










import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import Timer from '@/components/Timer.vue';


@Component({
  components: {
      Timer,
  },
})
export default class TimedCount extends Vue {
  @Prop()
  public time: number;

  @Prop()
  public value: number;

  @Prop()
  public title: string;
}
